'use client';

import { AuthProvider } from '@/components/AuthProvider';
import { PWARegistration } from '@/components/pwa-registration';
import { Toaster } from '@/components/ui/toaster';
import type { SessionUser } from '@/lib/types';
import { Toaster as SonnerToaster } from 'sonner';

export function AppShellProviders({
  children,
  initialUser,
}: {
  children: React.ReactNode;
  initialUser: SessionUser | null;
}) {
  return (
    <AuthProvider initialUser={initialUser}>
      <PWARegistration />
      {children}
      <Toaster />
      <SonnerToaster position="top-right" richColors theme="dark" />
    </AuthProvider>
  );
}